export default __webpack_public_path__ + "static/media/axsLogoSvg.eb6c76f9.svg";